const FIELD_ALIASES = {
  mail: [
    '邮箱地址',
    '电子邮箱',
    '邮箱',
    'email address',
    'email',
    'e-mail',
    'mail',
  ],
  name: [
    '授权用户名称',
    '授权用户',
    '授权名称',
    '授权名',
    '用户名称',
    '用户名',
    'licensee name',
    'licensee',
  ],
  url: [
    '服务器访问url',
    '服务器访问地址',
    '访问url',
    '访问地址',
    '访问域名',
    '服务器url',
    'server url',
    'url',
    'domain',
  ],
  serverid: [
    'server id',
    'serverid',
    '服务器 id',
    '服务器id',
    '服务器编号',
  ],
};

const normalizeLabel = (label) => label
  .toLowerCase()
  .replace(/[\s_\-—–/\\()（）]+/g, '')
  .trim();

const NORMALIZED_ALIASES = Object.entries(FIELD_ALIASES).reduce((result, [field, aliases]) => {
  aliases.forEach((alias) => {
    result.set(normalizeLabel(alias), field);
  });
  return result;
}, new Map());

const cleanValue = (value) => {
  const markdownLink = value.match(/\[[^\]]*\]\((https?:\/\/[^)\s]+)\)/i);
  const extractedValue = markdownLink ? markdownLink[1] : value;

  return extractedValue
    .trim()
    .replace(/^\s*[`'"“”‘’<]+|[`'"“”‘’>]+\s*$/g, '')
    .replace(/\\([@.:/])/g, '$1')
    .replace(/[；;，,。]+$/g, '')
    .trim();
};

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const URL_PATTERN = /^https?:\/\/[^\s]+$/i;
const SERVER_ID_PATTERN = /^[a-z0-9]{4}(?:-[a-z0-9]{4}){3}$/i;
const LABELED_SERVER_ID_PATTERN = /^(?:server\s*id|服务器\s*id|服务器编号)\s*(?:[：:=]\s*)?([a-z0-9]{4}(?:-[a-z0-9]{4}){3})\s*$/i;

const inferFieldFromValue = (value) => {
  if (EMAIL_PATTERN.test(value)) return 'mail';
  if (URL_PATTERN.test(value)) return 'url';
  if (SERVER_ID_PATTERN.test(value)) return 'serverid';
  return null;
};

export const LICENSE_INFO_FIELDS = [
  { key: 'mail', label: '邮箱地址' },
  { key: 'name', label: '授权用户名称' },
  { key: 'url', label: '服务器访问 URL' },
  { key: 'serverid', label: 'Server ID' },
];

export const parseLicenseInfoText = (rawText = '') => {
  const values = {};
  const unlabeledValues = [];

  rawText
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .forEach((sourceLine) => {
      const line = sourceLine
        .replace(/^\s*(?:[-*•]\s*|\d+\s*[.)、．]\s*)/, '')
        .trim();

      if (!line) return;

      const fieldMatch = line.match(/^(.{1,40}?)[：:=]\s*(.+)$/);
      if (fieldMatch) {
        const field = NORMALIZED_ALIASES.get(normalizeLabel(fieldMatch[1]));

        if (field) {
          const value = cleanValue(fieldMatch[2]);
          if (value) values[field] = value;
          return;
        }
      }

      // 兼容没有分隔符的 Server ID，例如：
      // "Server ID BBVX-DDW4-J53K-HCWZ" 和 "Server IDBBVX-DDW4-J53K-HCWZ"。
      const labeledServerIdMatch = line.match(LABELED_SERVER_ID_PATTERN);
      if (labeledServerIdMatch) {
        values.serverid = labeledServerIdMatch[1];
        return;
      }

      const value = cleanValue(line);
      if (value) unlabeledValues.push(value);
    });

  const possibleNames = [];

  unlabeledValues.forEach((value) => {
    const field = inferFieldFromValue(value);

    if (field) {
      // Explicitly labeled values always take precedence over inferred values.
      if (!values[field]) values[field] = value;
      return;
    }

    possibleNames.push(value);
  });

  // A free-form value has no reliable signature, so only infer the name when
  // exactly one unclassified line remains. This avoids silently filling the
  // field with unrelated pasted notes.
  if (!values.name && possibleNames.length === 1) {
    values.name = possibleNames[0];
  }

  return {
    values,
    recognizedCount: Object.keys(values).length,
  };
};
